export type Volume = {
  number: string
  title: string
  subtitle: string
  problem: string[]
  extraList?: { label: string; items: string[] }
  listLabel: string
  bullets: string[]
  flow?: { label: string; steps: string[] }
  result: string[]
}

export const volumes: Volume[] = [
  {
    number: 'VOLUME 01',
    title: 'Fondamentaux de la Danse Classique & Placement',
    subtitle:
      'Construisez des bases techniques solides dès les premières classes.',
    problem: [
      'La progression technique commence par des bases claires.',
      'Ce volume vous aide à enseigner et corriger les éléments fondamentaux avant d’augmenter progressivement la difficulté.',
    ],
    listLabel: 'Vous travaillez notamment :',
    bullets: [
      'posture',
      'placement',
      'alignement',
      'turnout',
      'positions des pieds',
      'positions des bras',
      'port de tête',
      'transfert du poids',
      'coordination',
      'équilibre de base',
      'contrôle corporel',
      'premières corrections techniques',
    ],
    result: [
      'Vous disposez d’une base structurée pour accompagner vos élèves avec davantage de cohérence dès les premières étapes.',
    ],
  },
  {
    number: 'VOLUME 02',
    title: 'La Barre : Technique, Exercices, Progressions & Corrections',
    subtitle:
      'Structurez votre travail à la barre sans devoir tout reconstruire chaque semaine.',
    problem: [
      'La barre est une partie essentielle du cours, mais créer continuellement de nouvelles séquences demande du temps.',
    ],
    listLabel: 'Ce volume organise les principaux éléments du travail à la barre :',
    bullets: [
      'pliés',
      'tendus',
      'dégagés',
      'ronds de jambe',
      'fondus',
      'frappés',
      'développés',
      'grands battements',
      'relevés',
      'transitions',
      'alignement',
      'stabilité',
      'corrections fréquentes',
      'progressions techniques',
    ],
    result: [
      'Votre travail à la barre devient plus structuré, progressif et cohérent d’une séance à l’autre.',
    ],
  },
  {
    number: 'VOLUME 03',
    title: 'Le Centre : Adage, Équilibre, Coordination & Placement',
    subtitle:
      'Faites passer vos élèves de la barre au centre avec une progression claire.',
    problem: [
      'Au centre, l’élève doit maintenir son placement, son équilibre et sa coordination sans le soutien de la barre.',
    ],
    listLabel:
      'Ce volume vous aide à structurer cette transition grâce à un travail autour de :',
    bullets: [
      'posture au centre',
      'axe',
      'équilibre',
      'adage',
      'ports de bras',
      'transfert du poids',
      'coordination',
      'contrôle',
      'musicalité',
      'transitions',
      'combinaisons au centre',
    ],
    result: [
      'Vos élèves développent davantage d’autonomie, de stabilité et de contrôle dans leur travail au centre.',
    ],
  },
  {
    number: 'VOLUME 04',
    title: 'Pirouettes, Tours, Sauts & Allegro',
    subtitle:
      'Un système entièrement visuel pour les mouvements les plus dynamiques de la danse classique.',
    problem: [
      'Les tours et les sauts demandent une progression claire et une observation technique précise.',
    ],
    listLabel: 'Ce volume travaille notamment :',
    bullets: [
      'relevé',
      'passé',
      'spotting',
      'préparation aux pirouettes',
      'pirouette simple',
      'en dehors',
      'en dedans',
      'progression des tours',
      'plié',
      'poussée',
      'articulation des pieds',
      'élévation',
      'réception',
      'sautés',
      'changements',
      'échappés',
      'assemblés',
      'jetés',
      'glissades',
      'petit allegro',
      'musicalité',
      'coordination bras-jambes',
    ],
    flow: {
      label: 'Vous trouverez régulièrement cette logique :',
      steps: ['Erreur', 'Correction', 'Exercice', 'Progression'],
    },
    result: [
      'Vous pouvez observer plus facilement les problèmes techniques et choisir une correction ou une progression adaptée.',
    ],
  },
  {
    number: 'VOLUME 05',
    title: 'Progressions, Niveaux, Corrections & Évaluation',
    subtitle:
      'Sachez où se trouve votre élève et ce qu’elle doit travailler ensuite.',
    problem: [
      'Enseigner ne consiste pas simplement à proposer des exercices.',
    ],
    extraList: {
      label: 'Il faut également savoir :',
      items: [
        'quand progresser',
        'quand ralentir',
        'quelle compétence renforcer',
        'quelle erreur corriger en priorité',
        'comment adapter la difficulté',
        'comment observer les progrès',
      ],
    },
    listLabel: 'Ce volume organise :',
    bullets: [
      'progressions par niveau',
      'priorités techniques',
      'critères d’observation',
      'erreurs fréquentes',
      'corrections',
      'évaluation',
      'suivi des élèves',
      'objectifs pédagogiques',
    ],
    result: [
      'Vous ne choisissez plus simplement le prochain exercice.',
      'Vous savez ce que vous cherchez à développer et pourquoi.',
    ],
  },
  {
    number: 'VOLUME 06',
    title: '150 Cours Prêts à Enseigner',
    subtitle:
      'Une bibliothèque complète pour arrêter de préparer chaque séance à partir de zéro.',
    problem: [
      'Certains jours, vous n’avez pas besoin d’une simple idée.',
      'Vous avez besoin d’une véritable structure de cours.',
      'Vous disposez de 150 cours prêts à enseigner, organisés autour de différents objectifs techniques.',
    ],
    listLabel: 'Vous pouvez travailler notamment :',
    bullets: [
      'fondamentaux',
      'posture',
      'placement',
      'barre',
      'centre',
      'équilibre',
      'coordination',
      'pirouettes',
      'tours',
      'sauts',
      'allegro',
      'corrections',
      'progression technique',
    ],
    result: [
      'Lorsque vous avez besoin d’une séance, vous avez déjà une structure sur laquelle vous appuyer.',
    ],
  },
]
